import React from 'react';

function ReferencesDataComponent(props) {
    const {referenceData} = props;
    const validReferences = (referenceData || []).filter(item => item && (item.name || item.title || item.email || item.phone));

    if (validReferences.length === 0) {
        return null;
    }

    return (
        
        <div className="accordion" id="referencesAccordion">                     
            {
                validReferences.map((item, idx) => {
                    return (
                        <p className="title" key={idx}>
                            <small><strong>{item.name}</strong></small> <br />
                            <small>{item.title}</small> <br />
                            <small>{item.email}</small> <br />
                            <small>{item.phone}</small> <br />
                        </p>
                    )
                })
            }
        </div>
    );
}

export default ReferencesDataComponent;